import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from "../../layouts/MenuVertical";
import { Icon, Button, Input, Loader } from "semantic-ui-react";
import { create } from "../../../actions/pagamento";
import moment from 'moment';
import { formatDecimal, getMesAno } from "../../../utils/formatador";
import api from "../../../api";
import Erro from '../../layouts/mensagens/Erro';
import { Redirect } from "react-router-dom";
import PagamentoNitrusFrame from "./PagamentoNitrusFrame";

import './Pagamento.css';

class Pagamento extends Component {

  constructor(props) {
    super(props);
    this.state = {
      condominio: {},
      loading: true,
      loadingCupom: false,
      etapa: 'plano',
      quantidade: 1,
      input_cupom: '',
      cupom: null,
      planos: [],
      planoSelecionado: null,
      errors: {
        cupom: null,
      }
    };
  }

  componentDidMount = async () => {
    try {
      const condominio = await api.condominio.findSimpleById(this.props.match.params.id);
      const planos = await api.pagamento.planos();

      this.setState({ loading: false, condominio, planos });

      if (this.isCondominioAtivo()) {
        // condomínio ativo mantém o plano atual: pula direto para a escolha das unidades
        this.setState({
          planoSelecionado: this.state.planos.find(it => it.value === (this.state.condominio.plano || 'PLANO_3')),
          etapa: 'quantidade',
        });
      }

    } catch(e) {
      this.setState({ loading: false, errors: (e.data && e.data.errors) || {} });
    }
    if (this.isRenovacao()) {
      this.setState({ quantidade: this.state.condominio.totalUnidades });
    }
  }

  onChangeSlider = e =>
    this.setState({
      [e.target.name]: parseInt(e.target.value.replace(/\D/g, ''), 10) || 0,
      errors: {}
    });

  setQuantidade = valor => this.setState({ quantidade: Math.max(1, Math.min(999, valor)), errors: {} });

  irParaEtapa = etapa => this.setState({ etapa });

  resetQuantidade = e => {
    if (this.state.quantidade === 0) {
      this.setState({
        [e.target.name]: 1,
        errors: {}
      });
    }
  }

  isCondominioAtivo = () => {
    // Dias para liberar a renovação de um plano ainda ativo
    const days = !this.state.condominio.plano || this.state.condominio.plano !== 'PLANO_1' ? 15 : 5;
    return this.state.condominio.dataVencimento && moment(this.state.condominio.dataVencimento).diff(moment(), 'days') > days;
  }

  isRenovacao = () =>
    !this.isCondominioAtivo() && this.state.condominio.dataPagamento && this.state.condominio.dataVencimento;

  confirmarCompra = async () => {
    this.setState({ etapa: 'pagamento' });

    const pagamento = await this.props.create({
      quantidade: this.state.quantidade,
      condominio: this.state.condominio._id,
      cupom: !!this.state.cupom && this.state.cupom.codigo,
      plano: this.state.planoSelecionado.value,
    });

    this.setState({
      loading: false,
      pagamento,
      errors: { ...this.props.errors, ...this.props.errorsPagamento },
    });
  }

  onStatusPagamento = atualizado =>
    this.setState(p => ({ pagamento: { ...p.pagamento, ...atualizado } }));

  getProximaDataPagamento = () => {
    return getMesAno(moment().add((this.state.planoSelecionado && this.state.planoSelecionado.meses) || 0, 'month').toDate());
  }

  onChange = e =>
    this.setState({
      [e.target.name]: e.target.value
    });

  aplicarCupom = async () => {
    if (this.state.input_cupom) {
      this.setState({ loadingCupom: true });
      try {
        const cupom = await api.cupom.check(this.state.input_cupom);
        this.setState({ loadingCupom: false, cupom });
      } catch(e) {
        this.setState({
          loadingCupom: false,
          errors: { cupom: !!e.data && !!e.data.errors && e.data.errors.error },
        });
      }
    }
  }

  changePlano = ({ currentTarget }) => {
    const plano = currentTarget.getAttribute('plano');
    this.setState({ planoSelecionado: this.state.planos.find(it => it.value === plano) });
  }

  getItemPlano = (plano, disableClick, dataValidade) => {
    const selecionado = this.state.planoSelecionado && this.state.planoSelecionado.value === plano.value;
    const melhor = this.state.planos.length > 0 &&
      plano.meses === Math.max(...this.state.planos.map(it => it.meses)) && !disableClick;
    const classNames = ['va-plano'];
    if (disableClick) classNames.push('no-click');
    if (selecionado && !disableClick) classNames.push('selected');

    return (
      <div
        className={classNames.join(' ')}
        onClick={disableClick ? null : this.changePlano}
        plano={plano.value}
        role={disableClick ? undefined : 'button'}
        tabIndex={disableClick ? undefined : 0}
        onKeyDown={disableClick ? undefined : e => (e.key === 'Enter' || e.key === ' ') && this.changePlano(e)}
      >
        {melhor && <div className="va-plano-selo">Melhor custo-benefício</div>}
        <h3>{plano.label}</h3>
        <div className="va-plano-preco"><small>R$</small> <b>{formatDecimal(plano.valorCondominio, ',', true)}</b></div>
        {plano.meses > 1 && <div className="va-plano-mes">equivale a R$ {formatDecimal(plano.valorCondominio / plano.meses)}/mês</div>}
        <ul>
          <li><Icon name="check" />R$ {formatDecimal(plano.valorUnidade)}/unidade votante</li>
          <li><Icon name="check" />Assembleias ilimitadas</li>
          <li><Icon name="check" />Aplicativo de votação</li>
        </ul>
        <div className="va-plano-validade">
          Válido até {dataValidade ? getMesAno(dataValidade) : getMesAno(moment().add(plano.meses, 'month').toDate())}
        </div>
        {!disableClick && selecionado && <div className="va-plano-check"><Icon name="check" /></div>}
      </div>
    );
  };

  getSubTotal = () => {
    let subTotal = this.state.planoSelecionado.valorUnidade * this.state.quantidade;
    if (!this.isCondominioAtivo()) {
      subTotal += this.state.planoSelecionado.valorCondominio;
    }
    return subTotal;
  }

  getTotal = () => {
    let total = this.getSubTotal();
    if (this.state.cupom) {
      total *= 100 - this.state.cupom.porcentagem;
      total /= 100;
    }
    return total;
  }

  getEtapas = () => {
    const ativo = this.isCondominioAtivo();
    return [
      { key: 'plano', label: 'Plano', icon: 'tags', pulada: ativo },
      { key: 'quantidade', label: 'Unidades', icon: 'building' },
      { key: 'pagamento', label: 'Pagamento', icon: 'credit card' },
      { key: 'concluido', label: 'Concluído', icon: 'flag checkered' },
    ];
  }

  renderStepper = () => {
    const etapas = this.getEtapas();
    const atual = etapas.findIndex(it => it.key === this.state.etapa);
    return (
      <ol className="va-stepper">
        {etapas.map((it, i) => (
          <li key={it.key} className={i < atual ? 'done' : i === atual ? 'active' : ''}>
            <span className="va-stepper-bolha">
              {i < atual ? <Icon name="check" /> : <Icon name={it.icon} />}
            </span>
            <span className="va-stepper-label">{it.label}{it.pulada ? ' (atual)' : ''}</span>
          </li>
        ))}
      </ol>
    );
  }

  renderResumo = () => {
    const { planoSelecionado, quantidade, cupom, pagamento, etapa, condominio } = this.state;
    const naEtapaPagamento = etapa === 'pagamento';
    const renovacao = this.isCondominioAtivo()
      ? getMesAno(condominio.dataVencimento)
      : this.getProximaDataPagamento();
    const total = naEtapaPagamento && pagamento && pagamento.valor ? pagamento.valor : planoSelecionado && this.getTotal();

    return (
      <aside className="va-resumo">
        <h3>Resumo do pedido</h3>
        <div className="va-resumo-linha"><span>Condomínio</span><b>{condominio.nome || '-'}</b></div>
        <div className="va-resumo-linha"><span>Plano</span><b>{planoSelecionado ? planoSelecionado.label : 'Selecione um plano'}</b></div>
        {planoSelecionado && (
          <>
            <div className="va-resumo-linha"><span>Unidades votantes</span><b>{quantidade}</b></div>
            {!this.isCondominioAtivo() && (
              <div className="va-resumo-linha"><span>Taxa do plano</span><b>R$ {formatDecimal(planoSelecionado.valorCondominio)}</b></div>
            )}
            <div className="va-resumo-linha"><span>Unidades ({quantidade} x R$ {formatDecimal(planoSelecionado.valorUnidade)})</span><b>R$ {formatDecimal(planoSelecionado.valorUnidade * quantidade)}</b></div>
            {!!cupom && (
              <div className="va-resumo-linha desconto"><span>Cupom {cupom.porcentagem}% de desconto</span><b>- R$ {formatDecimal(this.getSubTotal() - this.getTotal())}</b></div>
            )}
            <div className="va-resumo-total">
              <span>Total</span>
              <b>{total ? `R$ ${formatDecimal(total)}` : <Loader inline active size="tiny" />}</b>
            </div>
            <p className="va-resumo-renova"><Icon name="calendar alternate outline" /> Próxima renovação em <b>{renovacao}</b></p>
          </>
        )}
        <div className="va-seguro"><Icon name="lock" /> Pagamento seguro processado pelo Nitrus</div>
      </aside>
    );
  }

  renderEtapaPlano = () => {
    const { planos, planoSelecionado } = this.state;
    return (
      <section>
        <h2>Escolha o plano</h2>
        <p className="va-sub">Quanto maior o período, menor o valor mensal. Você pode ampliar as unidades votantes depois.</p>
        <div className="va-planos">
          {planos.map(it => <div key={it.value}>{this.getItemPlano(it, false)}</div>)}
        </div>
        <div className="va-acoes">
          <Button className="btn-ui-1" size="large" disabled={!planoSelecionado} onClick={() => this.irParaEtapa('quantidade')}>
            Continuar <Icon name="arrow right" />
          </Button>
        </div>
      </section>
    );
  }

  renderEtapaQuantidade = () => {
    const { quantidade, input_cupom, cupom, loadingCupom, loading, errors, condominio } = this.state;
    const ativo = this.isCondominioAtivo();
    return (
      <section>
        {ativo && (
          <div className="va-plano-atual">
            <h2>Meu plano</h2>
            <div style={{ maxWidth: 300 }}>
              {this.getItemPlano(this.state.planoSelecionado, true, condominio.dataVencimento)}
            </div>
          </div>
        )}
        <h2>{ativo ? 'Quantas unidades deseja adicionar?' : 'Quantas unidades votantes?'}</h2>
        <p className="va-sub">Uma unidade votante é um apartamento ou sala que poderá votar nas assembleias.</p>

        <div className="va-quantidade">
          <button type="button" aria-label="Diminuir" onClick={() => this.setQuantidade(quantidade - 1)}><Icon name="minus" /></button>
          <input
            type="text"
            inputMode="numeric"
            name="quantidade"
            aria-label="Quantidade de unidades votantes"
            value={quantidade}
            onChange={this.onChangeSlider}
            onBlur={this.resetQuantidade}
          />
          <button type="button" aria-label="Aumentar" onClick={() => this.setQuantidade(quantidade + 1)}><Icon name="plus" /></button>
        </div>
        <input
          type="range" min="1" max="999" value={quantidade} name="quantidade"
          className="ui-slider" onChange={this.onChangeSlider}
          aria-label="Quantidade de unidades votantes"
        />
        <div className="va-atalhos">
          {[10, 25, 50, 100, 200].map(n => (
            <button type="button" key={n} className={quantidade === n ? 'ativo' : ''} onClick={() => this.setQuantidade(n)}>{n}</button>
          ))}
        </div>

        {ativo && (
          <p className="va-sub" style={{ marginTop: 16 }}>
            Hoje: <b>{condominio.totalUnidades}</b> → depois: <b style={{ color: '#e83c6e' }}>{condominio.totalUnidades + quantidade}</b> unidades votantes
          </p>
        )}

        <div className="va-cupom">
          {cupom ? (
            <div className="va-cupom-ok"><Icon name="ticket" /> {cupom.descricao} - {cupom.porcentagem}% de desconto aplicado</div>
          ) : (
            <>
              <label htmlFor="input_cupom">Tem um cupom de desconto?</label>
              <div className="va-cupom-linha">
                <Input id="input_cupom" name="input_cupom" placeholder="MEUCUPOM10" onChange={this.onChange} value={input_cupom} />
                <Button loading={loadingCupom} disabled={loadingCupom || !input_cupom} onClick={this.aplicarCupom}>Aplicar</Button>
              </div>
              <Erro text={errors.cupom} />
            </>
          )}
        </div>

        <div className="va-acoes">
          {!ativo && <Button basic size="large" onClick={() => this.irParaEtapa('plano')}><Icon name="arrow left" /> Voltar</Button>}
          <Button loading={loading} disabled={loading} className="btn-ui-1" size="large" name="pagamento" onClick={this.confirmarCompra}>
            Ir para o pagamento <Icon name="arrow right" />
          </Button>
        </div>
      </section>
    );
  }

  renderEtapaPagamento = () => {
    const { pagamento } = this.state;
    return (
      <section>
        <h2>Pagamento</h2>
        <p className="va-sub">Escolha PIX ou boleto na página segura do Nitrus. Esta tela acompanha o pagamento.</p>
        <PagamentoNitrusFrame pagamento={pagamento} onStatus={this.onStatusPagamento} />
        {pagamento && pagamento.status === 'CA' && (
          <div className="va-alerta-erro">Esta cobrança foi cancelada. Recarregue a página para gerar um novo pedido.</div>
        )}
        {!!this.state.errors && !!this.state.errors.error && !pagamento && (
          <div className="va-alerta-erro">{this.state.errors.error}</div>
        )}
        <div className="va-aviso">
          <p>
            <b>PIX:</b> a compra é liberada em poucos minutos. <b>Boleto:</b> aguarde a compensação de 1 a 3 dias úteis.
            Você receberá um e-mail de confirmação e esta tela avança sozinha assim que o pagamento for confirmado.
          </p>
        </div>
        <div className="va-confianca-nitrus">
          <img src="/images/pagamento/nitrus.png" alt="Nitrus" height="56" />
          <p>
            O <b>Nitrus</b> é nosso parceiro no recebimento de cobranças: uma plataforma altamente confiável,
            que segue os padrões de segurança do mercado. Você pode pagar com tranquilidade.
          </p>
        </div>
      </section>
    );
  }

  render() {
    const { condominio, etapa, pagamento } = this.state;

    return (
      <div>
        {!!pagamento && (pagamento.origem === 'MANUAL' || pagamento.status === 'CO') && <Redirect to={`/condominios/${condominio._id}/comprar/sucesso`} />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} />
          <div className="va-checkout">
            {this.renderStepper()}
            <div className="va-checkout-corpo">
              <div className="va-checkout-main">
                {etapa === 'plano' && this.renderEtapaPlano()}
                {etapa === 'quantidade' && this.state.planoSelecionado && this.renderEtapaQuantidade()}
                {etapa === 'pagamento' && this.renderEtapaPagamento()}
              </div>
              {etapa !== 'plano' && this.renderResumo()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pagamento: state.pagamento.pagamento,
  errorsPagamento: state.pagamento.errors,
});

const mapDispatchToProps = dispatch => bindActionCreators({ create }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pagamento);
